/*
Portfolio sites for inspiration:
https://jacekjeznach.com    <<< this one especially
http://findmatthew.com
https://lokkeestudios.com
https://brittanychiang.com
*/

import { useSelector, useDispatch } from "react-redux";
import { setPageName } from "./redux/actions";
import { getWinSize, goPage } from "./system/coords";

// React
import { useEffect, useState, useRef, useCallback } from "react";

// Components
import NavOptions from "./components/nav";
import MainContent from "./components/main";
import Footer from "./components/footer";
import BackgroundVideo from "./components/background-video";

// CSS
import "./style/_app.css";
import "./style/about.css";
import "./style/arrows.css";
import "./style/clients.css";
import "./style/contact.css";
import "./style/demos.css";
import "./style/home.css";
import "./style/nav.css";
import "./style/showcase.css";
import "./style/tech.css";

// Structure

// Start our app
const App = () => {
  const [refreshKey, setRefreshKey] = useState(0);

  // Access the page name from the Redux store
  const pageName = useSelector(state => state.pageReducer);
  const pageNameRef = useRef(pageName);

  const dispatch = useDispatch();

  useEffect(() => {
    // Update the ref whenever pageName changes
    pageNameRef.current = pageName;
  }, [pageName]);

  // Actions to take on resize of window
  const handleResize = useCallback(() => {
    setRefreshKey(prevKey => prevKey + 1);
    goPage(pageNameRef.current);
    dispatch(setPageName(pageNameRef.current));
  }, [dispatch]);

  // On mount, add event listener to trigger handleResize function on resize event
  useEffect(() => {
    // Set an initial x, y position for the body
    document.body.style.left = "0";
    document.body.style.top = "0";

    window.addEventListener("resize", handleResize);

    // We want to remove the listener if the component is deleted or unmounted
    // (A cleanup task)
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [handleResize]);

  // Finally, return the JSX to be rendered
  return (
    <>
      <BackgroundVideo />
      <NavOptions />
      <MainContent width={getWinSize()[0]} height={getWinSize()[1]} refreshKey={refreshKey} />
      <Footer />
    </>
  );
};

export default App;
